import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

//constantes
const dataInicial = {
    data: {},
    fc_01: {},
    modoProceso: false,
    modoRecibidasCorregidas: false,
    modoVerDetalle: false,
}

//types
const GUARDAR_VIGENCIAS_DOCUMENTACION_EXITO = 'GUARDAR_VIGENCIAS_DOCUMENTACION_EXITO'
const AGREGAR_FC_01_EXITO_MAP = 'AGREGAR_FC_01_EXITO_MAP'
const ACTUALIZAR_ESTATUS_FC_01_EXITO = 'ACTUALIZAR_ESTATUS_FC_01_EXITO'
const ACTUALIZAR_FC_01_EXITO = 'ACTUALIZAR_FC_01_EXITO'
const OBTENER_DETALLE_FC_01_EXITO = 'OBTENER_DETALLE_FC_01_EXITO'
const OBTENER_DETALLE_FC_01_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_01_CON_MAPS_EXITO'
const ACTUALIZAR_FC_01_EXITO_MAP = 'ACTUALIZAR_FC_01_EXITO_MAP'
const ACTUALIZAR_MAPS_DOCUMENTACION_EXITO = 'ACTUALIZAR_MAPS_DOCUMENTACION_EXITO'
const ACEPTAR_SOLICITUD_EXITO = 'ACEPTAR_SOLICITUD_EXITO'
const OBTENER_DETALLE_FC_01_PARA_ACEPTAR_EXITO = 'OBTENER_DETALLE_FC_01_PARA_ACEPTAR_EXITO'

const ENVIAR_CORREO_EXITO = 'ENVIAR_CORREO_EXITO'
const GENERAR_OFICIOS_EXITO = 'GENERAR_OFICIOS_EXITO'
const OBTENER_FOLIO_OFICIO = 'OBTENER_FOLIO_OFICIO'
const ACTUALIZAR_FOLIO_OFICIO = 'ACTUALIZAR_FOLIO_OFICIO'
const ACTUALIZAR_LOGIN = 'ACTUALIZAR_LOGIN'
const OBTENER_REVISOR_EXITO = 'OBTENER_REVISOR_EXITO'
const OBTENER_CLIENTE_POR_FOLIO = 'OBTENER_CLIENTE_POR_FOLIO'
const AGREGAR_RELACIONES_EXITO = 'AGREGAR_RELACIONES_EXITO'
const GUARDAR_VIGENCIAS_DOM_EXITO = 'GUARDAR_VIGENCIAS_DOM_EXITO'
const ACTUALIZAR_MAPS_DOM_EXITO = 'ACTUALIZAR_MAPS_DOM_EXITO'
const ACTUALIZAR_FC_01_FORMULARIO_EXITO = 'ACTUALIZAR_FC_01_FORMULARIO_EXITO'

export const actualizarFC_01NumSocio = createAsyncThunk(
    ACTUALIZAR_FC_01_EXITO,
    async (data) => {
        try {
            // let fc_01 = data
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            await axios.put(fullUrlPrincipal, { data: data })
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const guardarVigenciasDocumentacion = createAsyncThunk(
    GUARDAR_VIGENCIAS_DOCUMENTACION_EXITO,
    async (dataDocumentacion) => {
        try {
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            const urlAgregarVigencia = host + `FC_01/actualizarFc_01_archivos`
            const urlAgregarMapfc_01_anexos = host + 'MapSolicitud/agregarMapFC_01_AnexosFiles'
            const urlAgregarMapfc_01_anexosrepresentantelegal = host + 'MapSolicitud/agregarFC_01_AnexosRepresentanteLegalMap'
            const urlAgregarMapfc_01_anexospersonaautorizada = host + 'MapSolicitud/agregarFC_01_AnexosPersonaAutorizadaMap'
            const urlAgregarMapfc_01_archivospredios = host + 'MapSolicitud/agregarFC_01_ArchivosPrediosMap'
            const urlAgregarMapfc_01_archivosviveros = host + 'MapSolicitud/agregarFC_01_ArchivosViverosMap'
            const urlAgregarMapfc_01_anexosmarca = host + 'MapSolicitud/agregarFC_01_AnexosMarcaMap'
            const urlAgregarMapfc_01_archivosmarcasproducto = host + 'MapSolicitud/agregarFC_01_ArchivosMarcasProductoMap'
            const urlAgregarMapfc_01_archivosinstalaciones = host + 'MapSolicitud/agregarFC_01_ArchivosInstalacionesMap'
            const urlAgregarMapfc_01_archivosresposansables = host + 'MapSolicitud/agregarFC_01_ArchivosResposansablesMap'

            const { documentacion, archivosGenerales } = dataDocumentacion
            for (const i in documentacion) {
                const { id, idAnexo, idMap, correcto, incorrecto, nameDoc, observaciones, ...data } = documentacion[i]

                if (data.estatus !== '' && data.estatus !== 'Agregar' && data.estatus !== undefined && data.estatus !== null) {
                    //res.data.data.fechadenacimiento = moment(fecha).add(1, 'd').format('YYYY-MM-DD')

                    if (data.fechaInicio !== '') {
                        data.fechaInicio = new Date(data.fechaInicio).toISOString()
                    }
                    if (data.fechaTermino !== '') {
                        data.fechaTermino = new Date(data.fechaTermino).toISOString()
                    }
                    const resAgregarVigencia = await axios.put(urlAgregarVigencia, data)
                }
                let idAnexoArchivo = idAnexo
                if (idAnexo === undefined) {
                    for (const j in archivosGenerales) {
                        if (archivosGenerales[j].nameid === data.nameid) {
                            idAnexoArchivo = archivosGenerales[j].idfc01_anexos
                        }
                    }
                }
                const dataMap = {
                    estatuscheck: incorrecto,
                    observacion: observaciones,
                }
                switch (data.tabla) {
                    case 'fc_01_anexos':
                        const dataMapFC_01 = {
                            nameidcheck: incorrecto,
                            nameid: observaciones,
                            idfc01_anexos: idAnexoArchivo
                        }
                        if (data.nameid === 'DGCP') {
                            const dataSolicitud = {
                                idfc01_solicitudregistro: data.idSolicitud,
                                comprobantepago: incorrecto,
                                comprobantepagotext: observaciones
                            }
                            await axios.put(fullUrlPrincipal, { data: dataSolicitud })
                        } else {
                            await axios.post(urlAgregarMapfc_01_anexos, { data: dataMapFC_01 })
                        }

                        break;
                    case 'fc_01_anexosrepresentantelegal':
                        dataMap.idanexorepresentantelegal = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_anexosrepresentantelegal, { data: dataMap })
                        break;
                    case 'fc_01_anexospersonaautorizada':
                        dataMap.idanexopersonaautorizada = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_anexospersonaautorizada, { data: dataMap })
                        break;
                    case 'fc_01_archivospredios':
                        dataMap.idarchivospredio = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_archivospredios, { data: dataMap })
                        break;
                    case 'fc_01_archivosviveros':
                        dataMap.idarchivosvivero = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_archivosviveros, { data: dataMap })
                        break;
                    case 'fc_01_anexosmarca':
                        dataMap.idanexomarca = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_anexosmarca, { data: dataMap })
                        break;
                    case 'fc_01_archivosmarcasproducto':
                        dataMap.idarchivosmarcaproducto = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_archivosmarcasproducto, { data: dataMap })
                        break;
                    case 'fc_01_archivosinstalaciones':
                        dataMap.idarchivosinstalacion = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_archivosinstalaciones, { data: dataMap })
                        break;
                    case 'fc_01_archivosresposansables':
                        dataMap.idarchivosresponsables = idAnexoArchivo
                        await axios.post(urlAgregarMapfc_01_archivosresposansables, { data: dataMap })
                        break;
                    default:
                        break;
                }
            }
            // const dataCartera = {
            //     iddatoslogin: data.usuarioModify.datoslogin.iddatoslogin,
            //     idcartera: data.cartera.id
            // }
            // const resAgregarVigencia = await axios.put(urlAgregarVigencia, {data: dataCartera})

        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarMapsDocumentacion = createAsyncThunk(
    ACTUALIZAR_MAPS_DOCUMENTACION_EXITO,
    async (dataDocumentacion) => {
        try {
            const urlAgregarVigencia = host + `FC_01/actualizarFc_01_archivos`
            const urlAgregarMapfc_01_anexos = host + 'MapSolicitud/agregarMapFC_01_AnexosFiles'
            const urlAgregarMapfc_01_anexosrepresentantelegal = host + 'MapSolicitud/agregarFC_01_AnexosRepresentanteLegalMap'
            const urlAgregarMapfc_01_anexospersonaautorizada = host + 'MapSolicitud/agregarFC_01_AnexosPersonaAutorizadaMap'
            const urlAgregarMapfc_01_archivospredios = host + 'MapSolicitud/agregarFC_01_ArchivosPrediosMap'
            const urlAgregarMapfc_01_archivosviveros = host + 'MapSolicitud/agregarFC_01_ArchivosViverosMap'
            const urlAgregarMapfc_01_anexosmarca = host + 'MapSolicitud/agregarFC_01_AnexosMarcaMap'
            const urlAgregarMapfc_01_archivosmarcasproducto = host + 'MapSolicitud/agregarFC_01_ArchivosMarcasProductoMap'
            const urlAgregarMapfc_01_archivosinstalaciones = host + 'MapSolicitud/agregarFC_01_ArchivosInstalacionesMap'
            const urlAgregarMapfc_01_archivosresposansables = host + 'MapSolicitud/agregarFC_01_ArchivosResposansablesMap'
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'

            const urlActualizarMapfc_01_anexos = host + 'MapSolicitud/actualizarMapFC_01_AnexosFiles'
            const urlActualizarMapfc_01_anexosrepresentantelegal = host + 'MapSolicitud/actualizarFC_01_AnexosRepresentanteLegalMap'
            const urlActualizarMapfc_01_anexospersonaautorizada = host + 'MapSolicitud/actualizarFC_01_AnexosPersonaAutorizadaMap'
            const urlActualizarMapfc_01_archivospredios = host + 'MapSolicitud/actualizarFC_01_ArchivosPrediosMap'
            const urlActualizarMapfc_01_archivosviveros = host + 'MapSolicitud/actualizarFC_01_ArchivosViverosMap'
            const urlActualizarMapfc_01_anexosmarca = host + 'MapSolicitud/actualizarFC_01_AnexosMarcaMap'
            const urlActualizarMapfc_01_archivosmarcasproducto = host + 'MapSolicitud/actualizarFC_01_ArchivosMarcasProductoMap'
            const urlActualizarMapfc_01_archivosinstalaciones = host + 'MapSolicitud/actualizarFC_01_ArchivosInstalacionesMap'
            const urlActualizarMapfc_01_archivosresposansables = host + 'MapSolicitud/actualizarFC_01_ArchivosResposansablesMap'

            const { documentacion, archivosGenerales } = dataDocumentacion

            for (const i in documentacion) {
                const { id, idAnexo, idMap, correcto, incorrecto, nameDoc, observaciones, ...data } = documentacion[i]

                if (data.estatus !== '' && data.estatus !== 'Agregar' && data.estatus !== undefined && data.estatus !== null) {

                    if (data.fechaInicio !== '') {
                        data.fechaInicio = new Date(data.fechaInicio).toISOString()
                    }
                    if (data.fechaTermino !== '') {
                        data.fechaTermino = new Date(data.fechaTermino).toISOString()
                    }
                    const resAgregarVigencia = await axios.put(urlAgregarVigencia, data)
                }
                let idAnexoArchivo = idAnexo
                if (idAnexo === undefined) {
                    for (const j in archivosGenerales) {
                        if (archivosGenerales[j].nameid === data.nameid) {
                            idAnexoArchivo = archivosGenerales[j].idfc01_anexos
                        }
                    }
                }
                const dataMap = {
                    estatuscheck: incorrecto,
                    observacion: observaciones,
                }
                switch (data.tabla) {
                    case 'fc_01_anexos':

                        const dataMapFC_01 = {
                            nameidcheck: incorrecto,
                            nameid: observaciones,
                            idfc01_anexomap: idMap
                        }
                        if (data.nameid === 'DGCP') {
                            const dataSolicitud = {
                                idfc01_solicitudregistro: data.idSolicitud,
                                comprobantepago: incorrecto,
                                comprobantepagotext: observaciones
                            }
                            await axios.put(fullUrlPrincipal, { data: dataSolicitud })
                        } else {

                            if (idMap !== '' && idMap !== null && idMap !== undefined) {

                                await axios.put(urlActualizarMapfc_01_anexos, { data: dataMapFC_01 })
                            } else {
                                dataMapFC_01.idfc01_anexos = documentacion[i].idFK
                                delete dataMapFC_01.idfc01_anexomap
                                await axios.post(urlAgregarMapfc_01_anexos, { data: dataMapFC_01 })
                            }
                        }
                        break;
                    case 'fc_01_anexosrepresentantelegal':
                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_anexorepresentantelegalmap = idMap
                            await axios.put(urlActualizarMapfc_01_anexosrepresentantelegal, { data: dataMap })
                        } else {
                            dataMap.idanexorepresentantelegal = idAnexo
                            await axios.post(urlAgregarMapfc_01_anexosrepresentantelegal, { data: dataMap })
                        }
                        break;
                    case 'fc_01_anexospersonaautorizada':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_anexospersonaautorizadamap = idMap
                            await axios.put(urlActualizarMapfc_01_anexospersonaautorizada, { data: dataMap })
                        } else {
                            dataMap.idanexopersonaautorizada = idAnexo
                            await axios.post(urlAgregarMapfc_01_anexospersonaautorizada, { data: dataMap })
                        }
                        break;
                    case 'fc_01_archivospredios':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_archivosprediosmap = idMap
                            await axios.put(urlActualizarMapfc_01_archivospredios, { data: dataMap })
                        } else {
                            dataMap.idarchivospredio = idAnexo
                            await axios.post(urlAgregarMapfc_01_archivospredios, { data: dataMap })
                        }
                        break;
                    case 'fc_01_archivosviveros':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_archivosviverosmap = idMap
                            await axios.put(urlActualizarMapfc_01_archivosviveros, { data: dataMap })
                        } else {
                            dataMap.idarchivosvivero = idAnexo
                            await axios.post(urlAgregarMapfc_01_archivosviveros, { data: dataMap })
                        }
                        break;
                    case 'fc_01_anexosmarca':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_anexosmarcamap = idMap
                            await axios.put(urlActualizarMapfc_01_anexosmarca, { data: dataMap })
                        } else {
                            dataMap.idanexomarca = idAnexo
                            await axios.post(urlAgregarMapfc_01_anexosmarca, { data: dataMap })
                        }
                        break;
                    case 'fc_01_archivosmarcasproducto':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_archivosmarcasproductomap = idMap
                            await axios.put(urlActualizarMapfc_01_archivosmarcasproducto, { data: dataMap })
                        } else {
                            dataMap.idarchivosmarcaproducto = idAnexo
                            await axios.post(urlAgregarMapfc_01_archivosmarcasproducto, { data: dataMap })
                        }
                        break;
                    case 'fc_01_archivosinstalaciones':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_archivosinstalacionesmap = idMap
                            await axios.put(urlActualizarMapfc_01_archivosinstalaciones, { data: dataMap })
                        } else {
                            dataMap.idarchivosinstalacion = idAnexo
                            await axios.post(urlAgregarMapfc_01_archivosinstalaciones, { data: dataMap })
                        }
                        break;
                    case 'fc_01_archivosresposansables':

                        if (idMap !== '' && idMap !== null && idMap !== undefined) {
                            dataMap.idfc01_archivosresposansablesmap = idMap
                            await axios.put(urlActualizarMapfc_01_archivosresposansables, { data: dataMap })
                        } else {
                            dataMap.idarchivosresponsables = idAnexo
                            await axios.post(urlAgregarMapfc_01_archivosresposansables, { data: dataMap })
                        }
                        break;
                    default:
                        break;
                }
            }
            // const dataCartera = {
            //     iddatoslogin: data.usuarioModify.datoslogin.iddatoslogin,
            //     idcartera: data.cartera.id
            // }
            // const resAgregarVigencia = await axios.put(urlAgregarVigencia, {data: dataCartera})

        } catch (error) {
            console.log(error)
        }
    }
)

export const agregarMapFC_01Accion = createAsyncThunk(
    AGREGAR_FC_01_EXITO_MAP,
    async (data) => {
        try {
            const observacionPrincipal = data.principalMap[0]
            const observacionesApoderadosLegales = data.apoderadoLegalMap
            const observacionesAnexoPersonaAut = data.personaAutorizadaMap
            const observacionesAnexoViveroMap = data.viveroMap
            const observacionesAnexoProductorMap = data.productorMap
            const observacionesAnexoMarca = data.marcaDeMezcalMap
            const observacionesAnexoProductosConMarca = data.marcaProductoConMezcalMap
            const observacionesAnexoInformacionGeneral = data.anexoPrincipalMap
            const observacionesAnexoResponsables = data.anexoResponsableMap
            //const observacionesAnexoPersonaAut = { data: data.observacionesPersonaAut }

            const agregarFC_01Map = host + `MapSolicitud/agregarMapFC_01_Solicitud`
            const agregarFC_01ApoderadoLegalMap = host + 'MapSolicitud/agregarMapFC_01_ApoderadoLegalMap'
            const agregarFC_01PersonaAutMap = host + 'MapSolicitud/agregarMapFC_01_AnexoPersonaAut'
            const agregarFC_01ViveroMap = host + 'MapSolicitud/agregarMapFC_01_PredioMap'
            const agregarFC_01ProductorMap = host + 'MapSolicitud/agregarMapFC_01_ProductorMap'
            const agregarFC_01MarcaMap = host + 'MapSolicitud/agregarMapFC_01_AnexoMarcasMap'
            const agregarFC_01MarcaConProductosMap = host + 'MapSolicitud/agregarMapFC_01_AnexoProductosConMarcasMap'
            const agregarFC_01AnexoInformacionGeneralMap = host + 'MapSolicitud/agregarMapFC_01_AnexoInformacionGeneralMap'
            const agregarFC_01AnexosResponsableMap = host + 'MapSolicitud/agregarMapFC_01_AnexoResponsablelMap'

            const res = await axios.post(agregarFC_01Map, { data: observacionPrincipal })

            for (const anexo of observacionesApoderadosLegales) {
                await axios.post(agregarFC_01ApoderadoLegalMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoPersonaAut) {
                await axios.post(agregarFC_01PersonaAutMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoViveroMap) {
                await axios.post(agregarFC_01ViveroMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoProductorMap) {
                await axios.post(agregarFC_01ProductorMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoMarca) {
                await axios.post(agregarFC_01MarcaMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoProductosConMarca) {
                await axios.post(agregarFC_01MarcaConProductosMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoInformacionGeneral) {
                await axios.post(agregarFC_01AnexoInformacionGeneralMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoResponsables) {
                await axios.post(agregarFC_01AnexosResponsableMap, { data: anexo })
            }
            return true
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarMapFC_01Accion = createAsyncThunk(
    ACTUALIZAR_FC_01_EXITO_MAP,
    async (data) => {
        try {
            const observacionPrincipal = data.principalMap[0]
            const observacionesApoderadosLegales = data.apoderadoLegalMap
            const observacionesAnexoPersonaAut = data.personaAutorizadaMap
            const observacionesAnexoViveroMap = data.viveroMap
            const observacionesAnexoProductorMap = data.productorMap
            const observacionesAnexoMarca = data.marcaDeMezcalMap
            const observacionesAnexoProductosConMarca = data.marcaProductoConMezcalMap
            const observacionesAnexoInformacionGeneral = data.anexoPrincipalMap
            const observacionesAnexoResponsables = data.anexoResponsableMap
            //const observacionesAnexoPersonaAut = { data: data.observacionesPersonaAut }

            // const agregarFC_01Map = host + `MapSolicitud/agregarMapFC_01_Solicitud`
            // const agregarFC_01ApoderadoLegalMap = host + 'MapSolicitud/agregarMapFC_01_ApoderadoLegalMap'
            // const agregarFC_01PersonaAutMap = host + 'MapSolicitud/agregarMapFC_01_AnexoPersonaAut'
            // const agregarFC_01ViveroMap = host + 'MapSolicitud/agregarMapFC_01_PredioMap'
            // const agregarFC_01ProductorMap = host + 'MapSolicitud/agregarMapFC_01_ProductorMap'
            // const agregarFC_01MarcaMap = host + 'MapSolicitud/agregarMapFC_01_AnexoMarcasMap'
            // const agregarFC_01MarcaConProductosMap = host + 'MapSolicitud/agregarMapFC_01_AnexoProductosConMarcasMap'
            // const agregarFC_01AnexoInformacionGeneralMap = host + 'MapSolicitud/agregarMapFC_01_AnexoInformacionGeneralMap'
            // const agregarFC_01AnexosResponsableMap = host + 'MapSolicitud/agregarMapFC_01_AnexoResponsablelMap'

            const actualizarFC_01Map = host + `MapSolicitud/actualizarMapFC_01_Solicitud`
            const actualizarFC_01ApoderadoLegalMap = host + 'MapSolicitud/actualizarMapFC_01_ApoderadoLegalMap'
            const actualizarFC_01PersonaAutMap = host + 'MapSolicitud/actualizarMapFC_01_AnexoPersonaAut'
            const actualizarFC_01ViveroMap = host + 'MapSolicitud/actualizarMapFC_01_PredioMap'
            const actualizarFC_01ProductorMap = host + 'MapSolicitud/actualizarMapFC_01_ProductorMap'
            const actualizarFC_01MarcaMap = host + 'MapSolicitud/actualizarMapFC_01_AnexoMarcasMap'
            const actualizarFC_01MarcaConProductosMap = host + 'MapSolicitud/actualizarMapFC_01_AnexoProductosConMarcasMap'
            const actualizarFC_01AnexoInformacionGeneralMap = host + 'MapSolicitud/actualizarMapFC_01_AnexoInformacionGeneralMap'
            const actualizarFC_01AnexosResponsableMap = host + 'MapSolicitud/actualizarMapFC_01_AnexoResponsableMap'

            const res = await axios.put(actualizarFC_01Map, { data: observacionPrincipal })

            for (const anexo of observacionesApoderadosLegales) {
                await axios.put(actualizarFC_01ApoderadoLegalMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoPersonaAut) {
                await axios.put(actualizarFC_01PersonaAutMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoViveroMap) {
                await axios.put(actualizarFC_01ViveroMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoProductorMap) {
                await axios.put(actualizarFC_01ProductorMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoMarca) {
                await axios.put(actualizarFC_01MarcaMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoProductosConMarca) {
                await axios.put(actualizarFC_01MarcaConProductosMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoInformacionGeneral) {
                await axios.put(actualizarFC_01AnexoInformacionGeneralMap, { data: anexo })
            }
            for (const anexo of observacionesAnexoResponsables) {
                await axios.put(actualizarFC_01AnexosResponsableMap, { data: anexo })
            }
            return true
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_01Estatus = createAsyncThunk(
    ACTUALIZAR_ESTATUS_FC_01_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusFC_01'
            await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFC_01 = createAsyncThunk(
    ACTUALIZAR_FC_01_EXITO,
    async (data) => {
        try {
            const actualizarPrincipal = data.principal[0]
            const actualizarApoderadosLegales = data.apoderadoLegal
            const actualizarAnexoPersonaAut = data.personaAutorizada
            const actualizarAnexoVivero = data.vivero
            const actualizarAnexoProductor = data.productor
            const actualizarAnexoMarca = data.marcaDeMezcal
            const actualizarAnexoProductosConMarca = data.marcaProductoConMezcal
            const actualizarAnexoInformacionGeneral = data.anexoPrincipal
            const actualizarAnexoResponsables = data.anexoResponsable

            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            const urlActualizarAnexoRepresentanteLegal = host + 'FC_01/actualizarAnexoRepresentateLegalFC_01'
            const urlActualizarAnexoPersonasAutorizadas = host + 'FC_01/actualizarAnexoPersonaAutorizadaTramitesFC_01'
            const urlActualizarAnexoPredios = host + 'FC_01/actualizarAnexoViveroFC_01'
            const urlActualizarAnexoProductor = host + 'FC_01/actualizarAnexoProductorFC_01'
            const urlActualizarAnexosMarcas = host + 'FC_01/actualizarAnexoMarcaDeSolicitudFC_01'
            const urlActualizarAnexosMarcasProductosConMezcal = host + 'FC_01/actualizarAnexoMarcaProductorConMezcalFC_01'
            const urlActualizarInformacionGeneral = host + 'FC_01/actualizarInformacionGeneral'
            const urlActualizarResponsable = host + 'FC_01/actualizarResponsable'

            for (const representante of actualizarApoderadosLegales) {
                await axios.put(urlActualizarAnexoRepresentanteLegal, { data: representante })
            }
            for (const personaAutorizada of actualizarAnexoPersonaAut) {
                await axios.put(urlActualizarAnexoPersonasAutorizadas, { data: personaAutorizada })
            }
            const res = await axios.put(fullUrlPrincipal, { data: actualizarPrincipal })
            for (const vivero of actualizarAnexoVivero) {
                await axios.put(urlActualizarAnexoPredios, { data: vivero })
            }
            for (const productor of actualizarAnexoProductor) {
                await axios.put(urlActualizarAnexoProductor, { data: productor })
            }
            for (const marcaDeMezcal of actualizarAnexoMarca) {
                await axios.put(urlActualizarAnexosMarcas, { data: marcaDeMezcal })
            }
            for (const marcaConMezcal of actualizarAnexoProductosConMarca) {
                await axios.put(urlActualizarAnexosMarcasProductosConMezcal, { data: marcaConMezcal })
            }
            for (const infoGeneral of actualizarAnexoInformacionGeneral) {
                await axios.put(urlActualizarInformacionGeneral, { data: infoGeneral })
            }
            for (const responsable of actualizarAnexoResponsables) {
                await axios.put(urlActualizarResponsable, { data: responsable })
            }
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerSolicitudDetalleFC_01 = createAsyncThunk(
    OBTENER_DETALLE_FC_01_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerUnaSolicitudFC_01Detalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerSolicitudDetalleFC_01ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_01_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerSolicitudFC_01DetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)

            for (const i in res.data.data.fc_01_anexos) {
                const data = {
                    fechafin: res.data.data.fc_01_anexos[i].fechafin,
                    fechainicio: res.data.data.fc_01_anexos[i].fechainicio,
                    estatus: res.data.data.fc_01_anexos[i].estatus,
                    nameid: res.data.data.fc_01_anexos[i].fc_01_anexosmap[0]?.nameid,
                    nameidcheck: res.data.data.fc_01_anexos[i].fc_01_anexosmap[0]?.nameidcheck,
                    idMap: res.data.data.fc_01_anexos[i].fc_01_anexosmap[0]?.idfc01_anexomap,
                    idFK: res.data.data.fc_01_anexos[i].idfc01_anexos,
                }
                switch (res.data.data.fc_01_anexos[i].nameid) {
                    case 'DGAC':
                        res.data.data.DGAC = data
                        break;
                    case 'DGPN':
                        res.data.data.DGPN = data
                        break;
                    case 'DGIOVREP':
                        res.data.data.DGIOVREP = data
                        break;
                    case 'DGCDF':
                        res.data.data.DGCDF = data
                        break;
                    case 'DGRFC':
                        res.data.data.DGRFC = data
                        break;
                    case 'DGC':
                        res.data.data.DGC = data
                        break;
                    case 'DGIOV':
                        res.data.data.DGIOV = data
                        break;
                    case 'DGCP':
                        res.data.data.DGCP = data
                        break;
                    default:
                        break;
                }
            }

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerSolicitudFC_01ParaAceptar = createAsyncThunk(
    OBTENER_DETALLE_FC_01_PARA_ACEPTAR_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerUnaSolicitudFC_01Detalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const aceptarSolicitudFC_01 = createAsyncThunk(
    ACEPTAR_SOLICITUD_EXITO,
    async (data) => {
        try {
            //1- obtenter todos los datos de la solicitud fc_01 para aceptar
            const solicitud = data.objetoCompletoFC_01.solicitudPrincipal
            const actividadCliente = data.objetoCompletoFC_01.actividadCliente
            const domicilioFiscal = data.objetoCompletoFC_01.domicilioFiscal
            const informacioFisica = data.objetoCompletoFC_01.informacioFisica
            const anexoInstalacion = data.objetoCompletoFC_01.instalaciones
            // const anexoUnidadEnvasado = data.objetoCompletoFC_01.anexoUnidadEnvasado
            // const anexoUnidadProduccion = data.objetoCompletoFC_01.anexoUnidadProduccion
            const marcas = data.objetoCompletoFC_01.marcas
            const marcasProduct = data.objetoCompletoFC_01.marcasProduct
            const mediosDeContacto = data.objetoCompletoFC_01.mediosDeContacto
            const personasAutorizadas = data.objetoCompletoFC_01.personasAutorizadas
            const viveros = data.objetoCompletoFC_01.viveros
            const predios = data.objetoCompletoFC_01.predios
            const representantesLegales = data.objetoCompletoFC_01.representantesLegales
            const estadisticaSocial = data.objetoCompletoFC_01.estadisticaSocial

            const filesGenerales = data.objetoCompletoFC_01.files

            const observacionComprobantePago = data.objetoCompletoFC_01.observacionComprobantePago

            const urlAgregarCliente = host + 'InformacionValida/agregarCliente'
            const urlAgregarDomicilioFiscal = host + 'InformacionValida/agregarDomicilioFiscalCliente'
            const urlAgregarInformacionPersonaFisica = host + 'InformacionValida/agregarInformacionPersonaFisicaCliente'
            const urlAgregarMedioDeContacto = host + 'InformacionValida/agregarMediosDeContactoCliente'
            const urlAgregarApoderadoLegal = host + 'InformacionValida/agregarApoderadosLegalesCliente'
            const urlAgregarRepresentanteAutorizado = host + 'InformacionValida/agregarRepresentantesAutorizadosCliente'
            const urlAgregarActividadCliente = host + 'InformacionValida/agregarActividadCliente'
            const urlAgregarPredio = host + 'InformacionValida/agregarPredioCliente'
            const urlAgregarVivero = host + 'InformacionValida/agregarViveroCliente'
            const urlAgregarTipoPlantacion = host + 'InformacionValida/agregarTipoPlantacion'
            const urlAgregarMarcasCliente = host + 'InformacionValida/agregarMarcasCliente'
            const urlAgregarMarcasProductCliente = host + 'InformacionValida/agregarMarcasProductoConMezcalCliente'
            const urlAgregarInformacionGeneralInstalacionCliente = host + 'InformacionValida/agregarInformacionGeneralInstalacionCliente'
            const urlAgregarInstalacionCliente = host + 'InformacionValida/agregarInstalacionesCliente'
            const urlAgregarResponsableDeInstalacionCliente = host + 'InformacionValida/agregarResponsablesDeInstalacionCliente'
            const urlAgregarAnexoCliente = host + 'InformacionValida/agregarAnexoCliente'
            const urlAgregarDataElementoCliente = host + 'InformacionValida/agregarDataElementoCliente'
            const urlAgregarEstadisticaSocialCliente = host + 'InformacionValida/agregarEstadisticaSocialCliente'

            const urlAgregarFile = host + 'InformacionValida/agregarArchivoCliente'

            // //2- Agregar cliente
            const resCliente = await axios.post(urlAgregarCliente, { data: solicitud })

            for (const j in filesGenerales) {
                const { idfc01_anexos, idfc01_solicitudregistro, idfc01_tipoanexos, fc_01_anexosmap, ...restFile } = filesGenerales[j]
                restFile.nombreTabla = 'archivosgeneralescliente'
                restFile.nameFK = 'idcliente'
                restFile.idFK = resCliente.data.data.idcliente
                if (restFile.nameid === 'DGCP') {
                    restFile.observaciones = observacionComprobantePago
                } else {
                    restFile.observaciones = fc_01_anexosmap?.[0]?.nameid
                }

                await axios.post(urlAgregarFile, { data: restFile })
            }

            // //3- Agregar Domicilio Fiscal
            domicilioFiscal.idcliente = resCliente.data.data.idcliente
            await axios.post(urlAgregarDomicilioFiscal, { data: domicilioFiscal })

            // //4- Agregar informacion de persona fisica
            informacioFisica.idcliente = resCliente.data.data.idcliente
            await axios.post(urlAgregarInformacionPersonaFisica, { data: informacioFisica })

            //4.5 Agregar estadistica social
            estadisticaSocial.idcliente = resCliente.data.data.idcliente
            await axios.post(urlAgregarEstadisticaSocialCliente, { data: estadisticaSocial })

            // //5- Agregar medios de contacto
            for (let i in mediosDeContacto) {
                const { id, idfc01_anexomediosdecontacto, idfc01_solicitudregistro, estado, ...anexoMediosDeContactoSinID } = mediosDeContacto[i]
                anexoMediosDeContactoSinID.idcliente = resCliente.data.data.idcliente
                await axios.post(urlAgregarMedioDeContacto, { data: anexoMediosDeContactoSinID })
            }
            // //6- Agregar apoderados legales
            for (let i in representantesLegales) {
                const { id, idfc01_anexorepresentantelegal, idfc01_solicitudregistro, fc_01_anexosrepresentantelegal, ...anexo } = representantesLegales[i]
                anexo.idcliente = resCliente.data.data.idcliente
                const resApoderado = await axios.post(urlAgregarApoderadoLegal, { data: anexo })
                for (const j in fc_01_anexosrepresentantelegal) {
                    const { idanexorepresentantelegal, idfc01_anexorepresentantelegal, idfc01_tipoanexos, fc_01_anexosrepresentantelegalmap, ...restFile } = fc_01_anexosrepresentantelegal[j]
                    restFile.nombreTabla = 'archivosapoderadoslegalescliente'
                    restFile.nameFK = 'idapoderadoslegales'
                    restFile.idFK = resApoderado.data.data.idapoderadoslegales
                    restFile.observaciones = fc_01_anexosrepresentantelegalmap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //7- Agregar Personas Autorizados 
            for (let i in personasAutorizadas) {
                const { id, idfc01_anexopersonaatorizadatramites, idfc01_solicitudregistro, fc_01_anexospersonaautorizada, ...anexo } = personasAutorizadas[i]
                anexo.idcliente = resCliente.data.data.idcliente
                const resPersonaAut = await axios.post(urlAgregarRepresentanteAutorizado, { data: anexo })
                for (const j in fc_01_anexospersonaautorizada) {
                    const { idanexopersonaautorizada, idfc01_anexopersonaatorizadatramites, idfc01_tipoanexos, fc_01_anexospersonaautorizadamap, ...restFile } = fc_01_anexospersonaautorizada[j]
                    restFile.nombreTabla = 'archivospersonasautorizadascliente'
                    restFile.nameFK = 'idrepresentantesautorizados'
                    restFile.idFK = resPersonaAut.data.data.idrepresentantesautorizados
                    restFile.observaciones = fc_01_anexospersonaautorizadamap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //8- Agregar Actividades del cliente
            if (actividadCliente.viverista) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 1, idcliente: resCliente.data.data.idcliente } })
            if (actividadCliente.productormaguey) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 2, idcliente: resCliente.data.data.idcliente } })
            if (actividadCliente.productormezcal) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 3, idcliente: resCliente.data.data.idcliente } })
            if (actividadCliente.envasador) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 4, idcliente: resCliente.data.data.idcliente } })
            if (actividadCliente.comercializadormezcal) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 5, idcliente: resCliente.data.data.idcliente } })
            if (actividadCliente.comercializadorbebidasconmezcal) await axios.post(urlAgregarActividadCliente, { data: { idtipoactividad: 6, idcliente: resCliente.data.data.idcliente } })
            // //9- Agregar predios 
            for (let i in predios) {
                const { id, idfc01_anexoproductor, idfc01_solicitudregistro, fc_01_archivospredios, ...anexo } = predios[i]
                anexo.idcliente = resCliente.data.data.idcliente
                const resPredio = await axios.post(urlAgregarPredio, { data: anexo })
                for (const j in fc_01_archivospredios) {
                    const { idarchivospredio, idfc01_anexoproductor, idfc01_tipoanexos, fc_01_archivosprediosmap, ...restFile } = fc_01_archivospredios[j]
                    restFile.nombreTabla = 'archivospredioscliente'
                    restFile.nameFK = 'idpredio'
                    restFile.idFK = resPredio.data.data.idpredio
                    restFile.observaciones = fc_01_archivosprediosmap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //10- Agregar viveros 
            for (let i in viveros) {
                const { id, idfc01_anexopredios, idfc01_solicitudregistro, fc_01_archivosviveros, ...anexo } = viveros[i]
                anexo.idcliente = resCliente.data.data.idcliente
                const resVivero = await axios.post(urlAgregarVivero, { data: anexo })
                for (const j in fc_01_archivosviveros) {
                    const { idarchivosvivero, idfc01_anexopredios, idfc01_tipoanexos, fc_01_archivosviverosmap, ...restFile } = fc_01_archivosviveros[j]
                    restFile.nombreTabla = 'archivosviveroscliente'
                    restFile.nameFK = 'idvivero'
                    restFile.idFK = resVivero.data.data.idvivero
                    restFile.observaciones = fc_01_archivosviverosmap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //11- Agregar Marcas 
            for (let i in marcas) {
                const { id, idfc01_anexomarcas, idfc01_solicitudregistro, fc_01_anexosmarca, anexoexistente, ...anexo } = marcas[i]
                anexo.idcliente = resCliente.data.data.idcliente
                anexo.idestatusmarca = 1
                const resMarcas = await axios.post(urlAgregarMarcasCliente, { data: anexo })
                for (const j in fc_01_anexosmarca) {
                    const { idanexomarca, idfc01_anexomarcas, idfc01_tipoanexos, fc_01_anexosmarcamap, ...restFile } = fc_01_anexosmarca[j]
                    restFile.nombreTabla = 'archivosmarcascliente'
                    restFile.nameFK = 'idmarcascliente'
                    restFile.idFK = resMarcas.data.data.idmarcascliente
                    restFile.observaciones = fc_01_anexosmarcamap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //11.5- Agregar Marcas Productor con mezcal 
            for (let i in marcasProduct) {
                const { id, idfc01_anexomarcasproductoconmezcal, idfc01_solicitudregistro, fc_01_archivosmarcasproducto, anexoexistente, ...anexo } = marcasProduct[i]
                anexo.idcliente = resCliente.data.data.idcliente
                anexo.idestatusmarca = 1
                const resMarcas = await axios.post(urlAgregarMarcasProductCliente, { data: anexo })
                for (const j in fc_01_archivosmarcasproducto) {
                    const { idarchivosmarcaproducto, idfc01_anexomarcasproductoconmezcal, idfc01_tipoanexos, fc_01_archivosmarcasproductomap, ...restFile } = fc_01_archivosmarcasproducto[j]
                    restFile.nombreTabla = 'archivosmarcasproductocliente'
                    restFile.nameFK = 'idmarcasproductocliente'
                    restFile.idFK = resMarcas.data.data.idmarcasproductocliente
                    restFile.observaciones = fc_01_archivosmarcasproductomap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }
            // //-------12 Agregar Instalaciones----
            // //12-1- Agregar informacion General del cliente

            // //12-2- Agregar instalaciones del cliente ---
            // //12-3- Agregar Responsables de instalaciones
            // //12-4- Agregar Anexo Cliente
            // //12-5- Agregar Data Elemento Cliente

            for (let i in anexoInstalacion) {
                const { id, dataelemento, fc_01_archivosinstalaciones, informaciongeneral,
                    tipoanexo, idtipoanexo, ...anexoInstalacionSinID } = anexoInstalacion[i]

                for (let x in anexoInstalacionSinID) {
                    if (anexoInstalacionSinID[x] === "") {
                        anexoInstalacionSinID[x] = null
                    }
                }

                // const {idfc01_solicitudregistro, idiformaciongeneral, idanexo, ...unidad} = anexoInstalacionSinID
                //     const {idfc01_solicitudregistro, idiformaciongeneral, idanexo, ...unidad} = anexoProduccionSinID
                const { idiformaciongeneral, instalaciones, responsablesdeinstalacion, otracalle, anexoexistente, ...restoInformacionGeneral } = informaciongeneral
                if (restoInformacionGeneral.calle === 'Otro') restoInformacionGeneral.calle = otracalle
                const informacionGeneralClienteAgregada = await axios.post(urlAgregarInformacionGeneralInstalacionCliente, { data: restoInformacionGeneral })
                const idiformaciongeneralcliente = informacionGeneralClienteAgregada.data.data.idiformaciongeneralcliente

                for (const j in instalaciones) {
                    let dataInstalacion = {
                        idiformaciongeneralcliente: idiformaciongeneralcliente,
                        idtipoinstalacion: instalaciones[j].idtipoinstalacion,
                    }
                    await axios.post(urlAgregarInstalacionCliente, { data: dataInstalacion })
                }

                const data = {
                    idcliente: resCliente.data.data.idcliente,
                    idtipoanexo: idtipoanexo,
                    idiformaciongeneralcliente: idiformaciongeneralcliente
                }
                const anexoAgregado = await axios.post(urlAgregarAnexoCliente, { data })
                const idanexocliente = anexoAgregado.data.data.idanexocliente

                for (const responsable of responsablesdeinstalacion) {
                    const { id, idiformaciongeneral, idresponsabledeinstalacion, fc_01_archivosresposansables, ...responsableSinID } = responsable
                    responsableSinID.idiformaciongeneralcliente = idiformaciongeneralcliente
                    const resResponsable = await axios.post(urlAgregarResponsableDeInstalacionCliente, { data: responsableSinID })
                    for (const j in fc_01_archivosresposansables) {
                        const { idarchivosresponsables, idresponsabledeinstalacion, idfc01_tipoanexos, fc_01_archivosresposansablesmap, ...restFile } = fc_01_archivosresposansables[j]
                        restFile.nombreTabla = 'archivosresposansablescliente'
                        restFile.nameFK = 'idresponsabledeinstalacioncliente'
                        restFile.idFK = resResponsable.data.data.idresponsabledeinstalacioncliente
                        restFile.observaciones = fc_01_archivosresposansablesmap?.[0]?.observacion
                        await axios.post(urlAgregarFile, { data: restFile })
                    }
                }

                for (const element of dataelemento) {
                    const { opcion, capacidad, idanexo, iddataelemento, elemento, ...dataElemento } = element
                    dataElemento.idanexocliente = idanexocliente
                    await axios.post(urlAgregarDataElementoCliente, { data: dataElemento })
                }
                for (const j in fc_01_archivosinstalaciones) {
                    const { idarchivosinstalacion, idanexo, idfc01_tipoanexos, fc_01_archivosinstalacionesmap, ...restFile } = fc_01_archivosinstalaciones[j]
                    restFile.nombreTabla = 'archivosinstalacionescliente'
                    restFile.nameFK = 'idanexocliente'
                    restFile.idFK = idanexocliente
                    restFile.observaciones = fc_01_archivosinstalacionesmap?.[0]?.observacion
                    await axios.post(urlAgregarFile, { data: restFile })
                }
            }


            //ultimo paso
            const fullUrl = host + 'Estatus/actualizarEstatusFC_01'
            await axios.post(fullUrl, data)
            return resCliente
        } catch (error) {
            console.log(error);
        }
    }
)

export const enviarCorreo = createAsyncThunk(
    ENVIAR_CORREO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/enviarCorreoContratos'
            await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
//
export const generarDocumentos = createAsyncThunk(
    GENERAR_OFICIOS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/generarOficios'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFolio = createAsyncThunk(
    OBTENER_FOLIO_OFICIO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerFolioOficio/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFolioOficio = createAsyncThunk(
    ACTUALIZAR_FOLIO_OFICIO,
    async (data) => {
        try {
            const fullUrl = host + `AtencionAClientes/actualizarFolioOficio`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarLogin = createAsyncThunk(
    ACTUALIZAR_LOGIN,
    async (data) => {
        try {
            const fullUrl = host + `AnexoUsuario/actualizarLogin`
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerRevisor = createAsyncThunk(
    OBTENER_REVISOR_EXITO,
    async (revisor) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerRevisor/${revisor}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerClientePorNoSocio = createAsyncThunk(
    OBTENER_CLIENTE_POR_FOLIO,
    async (numeroSocioCliente) => {
        try {
            const fullUrl = host + `AnexoUsuario/obtenerClientePorNoSocio/${numeroSocioCliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarRelaciones = createAsyncThunk(
    AGREGAR_RELACIONES_EXITO,
    async (data) => {
        try {

            let relaciones = data.relaciones
            let numerosocio = data.numeroDeSocio
            let idcliente = data.idCliente

            const fullUrl = host + 'AtencionAClientes/agregarNuevaRelacion'

            for (const i in relaciones) {
                if (relaciones[i].tipo === 'maquilador') {
                    let datos = {
                        numerosocio: numerosocio, envasado: relaciones[i].numero,
                        marca: relaciones[i].marca, idcliente: idcliente
                    }
                    await axios.post(fullUrl, { data: datos })
                } else {
                    let datos = {
                        numerosocio: numerosocio, productor: relaciones[i].numero,
                        marca: relaciones[i].marca, idcliente: idcliente
                    }
                    await axios.post(fullUrl, { data: datos })
                }

            }

            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarDOMap = createAsyncThunk(
    ACTUALIZAR_MAPS_DOM_EXITO,
    async (dataDocumentacion) => {
        try {
            const urlAgregarVigencia = host + `FC_01/actualizarFc_01_archivos`
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            const urlActualizarMapfc_01_anexos = host + 'MapSolicitud/actualizarMapFC_01_AnexosFiles'

            const urlAgregarMapfc_01_anexos = host + 'MapSolicitud/agregarMapFC_01_AnexosFiles'
            const data = {
                opciondom: dataDocumentacion.opcionDom, numerodom: dataDocumentacion.numerodom,
                idfc01_solicitudregistro: dataDocumentacion.idfc01_solicitudregistro
            }
            let result = await axios.put(fullUrlPrincipal, { data: data })

            if (dataDocumentacion?.file?.length>0) {

                if (dataDocumentacion.fechainiciodom !== '') {
                    dataDocumentacion.fechainiciodom = new Date(dataDocumentacion.fechainiciodom).toISOString()
                }
                if (dataDocumentacion.fechafindom !== '') {
                    dataDocumentacion.fechafindom = new Date(dataDocumentacion.fechafindom).toISOString()
                }
                if (dataDocumentacion?.file?.length > 0) {
                    const vigencia = {
                        fechaInicio: dataDocumentacion.fechafindom, fechaTermino: dataDocumentacion.fechainiciodom,
                        idSolicitud: dataDocumentacion?.file?.[0]?.idAnexo, tabla: 'fc_01_anexos',nombreId:'idfc01_anexos',
                        nameid: 'DGDO', estatus: dataDocumentacion.estatusdom
                    }
                    const resAgregarVigencia = await axios.put(urlAgregarVigencia, vigencia)
                }
            }

            if (dataDocumentacion?.file?.length > 0) {
                
                if(dataDocumentacion.fileMap.length>0){
                    const dataMap = {
                        nameidcheck: false,
                        nameid: dataDocumentacion.observacionesdom,
                        idfc01_anexos: dataDocumentacion?.file?.[0]?.idAnexo,
                        idfc01_anexomap: dataDocumentacion?.fileMap?.[0]?.idfc01_anexomap
                    }
                    let remap = await axios.put(urlActualizarMapfc_01_anexos, { data: dataMap })
                }else{
                    const dataMap = {
                        nameidcheck: false,
                        nameid: dataDocumentacion.observacionesdom,
                        idfc01_anexos: dataDocumentacion?.file?.[0]?.idAnexo
                    }
                    let remap = await axios.post(urlAgregarMapfc_01_anexos, { data: dataMap })
                }
                
            }
        } catch (error) {
            console.log(error)
        }
    }
)
export const AgregarDOMMap = createAsyncThunk(
    GUARDAR_VIGENCIAS_DOM_EXITO,
    async (dataDocumentacion) => {
        try {
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            const urlAgregarVigencia = host + `FC_01/actualizarFc_01_archivos`
            const urlAgregarMapfc_01_anexos = host + 'MapSolicitud/agregarMapFC_01_AnexosFiles'
            const data = {
                opciondom: dataDocumentacion.opcionDom, numerodom: dataDocumentacion.numerodom,
                idfc01_solicitudregistro: dataDocumentacion.idfc01_solicitudregistro
            }
            let result = await axios.put(fullUrlPrincipal, { data: data })
            if (dataDocumentacion?.file?.length > 0) {

                if (dataDocumentacion.fechainiciodom !== '') {
                    dataDocumentacion.fechainiciodom = new Date(dataDocumentacion.fechainiciodom).toISOString()
                }else{
                    dataDocumentacion.fechainiciodom = null
                }
                if (dataDocumentacion.fechafindom !== '') {
                    dataDocumentacion.fechafindom = new Date(dataDocumentacion.fechafindom).toISOString()
                }else{
                    dataDocumentacion.fechafindom = null
                }
                if (dataDocumentacion?.file?.length > 0) {
                    const vigencia = {
                        fechaInicio: dataDocumentacion.fechafindom, fechaTermino: dataDocumentacion.fechainiciodom,
                        idSolicitud: dataDocumentacion?.file?.[0]?.idAnexo, tabla: 'fc_01_anexos',nombreId:'idfc01_anexos',
                        nameid: 'DGDO', estatus: dataDocumentacion.estatusdom
                    }
                    const resAgregarVigencia = await axios.put(urlAgregarVigencia, vigencia)
                }
            }

            if (dataDocumentacion?.file?.length > 0) {
                const dataMap = {
                    nameidcheck: false,
                    nameid: dataDocumentacion.observacionesdom,
                    idfc01_anexos: dataDocumentacion?.file?.[0]?.idAnexo
                }
                let remap = await axios.post(urlAgregarMapfc_01_anexos, { data: dataMap })
            }
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_01Formulario = createAsyncThunk(
    ACTUALIZAR_FC_01_FORMULARIO_EXITO,
    async (data) => {
        try {
            const fullUrlPrincipal = host + 'FC_01/actualizarSolicitudFC_01'
            let res = await axios.put(fullUrlPrincipal, { data: data })
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const fc01Slice = createSlice({
    name: 'fc01Slice',
    initialState: dataInicial,
    reducers: {
        // guardarCambiosFC_01MapSolicitud(state, { payload }) {
        //     state.fc_01Map = payload
        // },
        setModoProceso(state, { payload }) {
            state.modoProceso = payload
        },
        setModoRecibidasCorregidas(state, { payload }) {
            state.modoRecibidasCorregidas = payload
        },
        setModoVerDetalleFC_01(state, { payload }) {
            state.modoVerDetalle = payload
        },
        resetDataFC_01(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [guardarVigenciasDocumentacion.fulfilled]: (state, { payload }) => {
        },
        [agregarMapFC_01Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_01Estatus.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_01.fulfilled]: (state, { payload }) => {
        },
        [obtenerSolicitudDetalleFC_01.fulfilled]: (state, { payload }) => {
            state.fc_01 = payload
        },
        [obtenerSolicitudDetalleFC_01ConMaps.fulfilled]: (state, { payload }) => {
            state.fc_01 = payload
        },
        [actualizarMapFC_01Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarMapsDocumentacion.fulfilled]: (state, { payload }) => {
        },
        [aceptarSolicitudFC_01.fulfilled]: (state, { payload }) => {
        },
        [obtenerSolicitudFC_01ParaAceptar.fulfilled]: (state, { payload }) => {
        },
        [enviarCorreo.fulfilled]: (state, { payload }) => {
        },
        [generarDocumentos.fulfilled]: (state, { payload }) => {
        },
        [obtenerFolio.fulfilled]: (state, { payload }) => {
        },
        [actualizarFolioOficio.fulfilled]: (state, { payload }) => {
        },
        [actualizarLogin.fulfilled]: (state, { payload }) => {
        },
        [obtenerRevisor.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_01NumSocio.fulfilled]: (state, { payload }) => {
        },
        [agregarRelaciones.fulfilled]: (state, { payload }) => {
        },
    }
})

export const {
    setModoProceso,
    setModoRecibidasCorregidas,
    setModoVerDetalleFC_01, resetDataFC_01
} = fc01Slice.actions
export const FC01ReducerAtencionACliente = fc01Slice.reducer